import classNames from 'classnames';
import React, { memo, useEffect, useRef, useState } from 'react';
import { VariableSizeList as List } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import styles from './GridInfinteScroll.module.less';
import { useActivate, useUnactivate } from 'react-activation';
import { scrollingDom } from '../../utils/utils';

function GridInfinteScroll(props) {
  const {
    dataSource, // 数据集
    height = 540, // 高
    width = 806, // 宽
    minimumBatchSize = 3, // 一行最多统一时间加载个数 默认10
    threshold = 3, // 预加载个数
    getItemSize, // 虚拟列表加载个数
    loadData, // 异步加载更多
    className = '',
    rowClassName = 'defaultInfinte',
    count = 0,
    column = 1,
    template,
    tpl,
  } = props;
  const [data, SetData] = useState([]);
  const [scroll, setScroll] = useState(false);
  const [node, setNode] = useState(null);
  const [el, setEl] = useState(null);

  const listRef = useRef(null);

  const handleScroll = () => {
    if (el && el.scrollTop > 1500) {
      setScroll(true);
    } else if (el) {
      setScroll(false);
    }
  };

  const handleScrollToTop = () => {
    let speed = 80;
    if (el && el.scrollTop > 0) {
      if (el.scrollTop > 1000) {
        speed = parseInt(el.scrollTop / 1000) * 50;
      }
      scrollingDom(el, 0, speed);
    }
    // const timer = setTimeout(() => {
    //   listRef.current.scrollToItem(0);
    //   clearTimeout(timer);
    // }, 2000);
  };
  useEffect(() => {
    if (node) {
      setEl(node.querySelector('div'));
    }
  }, [node]);
  useEffect(() => {
    if (el) {
      el.addEventListener('scroll', handleScroll);
    }
  }, [el]);
  useEffect(() => {
    return () => {
      if (el) {
        el.removeEventListener('scroll', handleScroll);
      }
    };
  }, [el]);
  useActivate(() => {
    if (el) {
      el.addEventListener('scroll', handleScroll);
    }
  });
  useUnactivate(() => {
    if (el) {
      el.removeEventListener('scroll', handleScroll);
    }
  });

  useEffect(() => {
    if (listRef.current) {
      data.forEach((_, i) => listRef.current.resetAfterIndex(i));
    }

    SetData(() => {
      const list = dataSource.reduce((result, item, index) => {
        // eslint-disable-next-line radix
        const key = parseInt(index / column);
        if (result && result[key]) {
          result[key].push(item);
        } else {
          // eslint-disable-next-line no-param-reassign
          result[key] = [item];
        }
        return result;
      }, []);
      if (dataSource.length < count) {
        list.push(null);
      }

      return list;
    });
  }, [dataSource]);

  const loadMoreItems = (startIndex, stopIndex) => {
    loadData(startIndex, stopIndex);
  };

  const Row = ({ index, style }) => {
    return (
      <div style={style}>
        {index === 0 && tpl && tpl()}
        <div className={styles.rowInfinte}>
          {data &&
            data[index] &&
            data[index].map((item, key) => (
              <div key={`${index}_${key}`} className={classNames(styles.rowInfinteItem)}>
                {template(item, key)}
              </div>
            ))}
        </div>
        {index === data.length - 1 && dataSource.length < count && (
          <div className={styles.loader}>----------加载中----------</div>
        )}
        {index === data.length - 1 && dataSource.length >= count && dataSource.length > 12 && (
          <div className={styles.loader}>----------到底啦----------</div>
        )}
      </div>
    );
  };

  if (!data || data.length < 1) {
    if (tpl) {
      return <>{tpl()}</>;
    }
    return null;
  }
  return (
    <div className={styles.InfiniteScroll} ref={r => setNode(r)}>
      <InfiniteLoader
        isItemLoaded={index => {
          return !!data[index];
        }}
        itemCount={data && data.length}
        loadMoreItems={loadMoreItems}
        minimumBatchSize={minimumBatchSize}
        threshold={threshold}
      >
        {({ onItemsRendered, ref }) => (
          <List
            width={width}
            height={height}
            itemSize={getItemSize}
            itemCount={data.length}
            // layout="vertical"
            // className={`day-photos ${className}`}
            onItemsRendered={onItemsRendered}
            ref={list => {
              ref(list);
              listRef.current = list;
            }}
            useIsScrolling
          >
            {Row}
          </List>
        )}
      </InfiniteLoader>
      {scroll && <div className={styles.scroll_top} onClick={handleScrollToTop}></div>}
    </div>
  );
}

export default memo(GridInfinteScroll);
